import React, { useState, useRef, useEffect, useMemo } from "react";

/** Components */
import { TextField, Dialog, Button, ButtonGroup, Table, TableHead, TableBody, TableCell, Autocomplete, TableRow, IconButton, TableContainer, Skeleton, MenuItem, Select, Paper } from "@mui/material";
import { FilterBy } from "../../commons/filter.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import { TruckFTReview } from "../commons/fuelTicketPreview.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */
import ClearIcon from "@mui/icons-material/Clear";

/** Api & Function */
import { getInventory, getVehicle, getDriver, getProduct, getProductUnit, postConversion, getCustomers, createTruckFT, replaceTruckFT } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import moment from "moment";

/** Hook */
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

const initialProduct = {
  temp: "",
  density: "",
  quantity: "",
  unit: null,
  l15: "",
  d15: "",
  vcf: "",
  wcf: "",
  kg: "",
  gallon: "",
  tank: null,
};

function CreateTruckTicket() {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const [t] = useTranslation();
  //redux state
  const user = useSelector((state) => state.user.data);
  //state
  const [input, setInput] = useState({
    customer: null,
    startdate: moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"),
    enddate: moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"),
    invoiceForm: null,
    inventory_cert: "",
    driver: null,
    from_inventory: null,
    to_inventory: null,
    vehicle: null,
    orderno: "",
    invoiceproducts: location.state ? [] : [{ ...initialProduct }],
    contract_date: "",
    contract_no: "",
    saletype: null,
    loadingtype: null,
    ext_vh_tanks: undefined,
    billdate: "",
    ext_inv_serial: "",
    product: null,
    note: "",
  });
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dtype, setDtype] = useState(2); // cach thuc nhap hang hoa (nhap tay hoac nhap theo d15)
  const isReplace = Boolean(location.state);
  const renderTable = useMemo(() => {
    switch (dtype) {
      case 0:
        return <TableProduct0 inputData={input} setInputData={setInput} />;
      case 1:
        return <TableProduct1 inputData={input} setInputData={setInput} />;
      case 2:
        return <TableProduct2 inputData={input} setInputData={setInput} />;
      default:
        return <></>;
    }
  }, [dtype, input]);

  //method
  const data = {
    valid_date: moment(input.billdate).format("YYYY-MM-DD"),
    start_pump: moment(input.startdate).format("YYYY-MM-DD HH:mm"),
    end_pump: moment(input.enddate).format("YYYY-MM-DD HH:mm"),
    customer_id: input.customer?.id,
    customer_name: input.customer?.name,
    customer_tax: input.customer?.tax_code,
    customer_address: input.customer?.address,
    inventory_id: input.from_inventory?.id,
    truck_id: input.vehicle?.id || null,
    refueler_license_plate: input.vehicle?.license_plate,
    provider_id: input.vehicle?.provider_id || null,
    provider_name: input.vehicle?.owner_company,
    driver: input.driver?.name,
    driver_id: input.driver?.id,
    ext_inv_serial: input.ext_inv_serial,
    note: input.note,
    product_name: input.product?.name,
    product_id: input.product?.id,
    productunit_code: input.invoiceproducts[0]?.unit?.shortname,
    productunit_id: input.invoiceproducts[0]?.unit?.id,
    caltype: dtype,
    cert_no: input.inventory_cert,
    density: dtype === 0 ? input.invoiceproducts[0].density : null,
    temp: input.invoiceproducts[0].temp,
    d15: input.invoiceproducts[0].d15,
    vcf: input.invoiceproducts[0].vcf,
    wcf: input.invoiceproducts[0].wcf,
    l15: input.invoiceproducts[0].l15,
    kg: input.invoiceproducts[0].kg,
    lit: input.invoiceproducts[0].lit,
    gallon: input.invoiceproducts[0].gallon,
    quantity: input.invoiceproducts[0].quantity,
    tank_id: input.invoiceproducts[0].tank?.id,
  };
  const handleSubmit = () => {
    if (location.state?.id) return replaceTruckFT(location.state.id, data);
    return createTruckFT(data);
  };
  const handleSubmitResponse = (res) => {
    if (res.code === 200) history.push(`/fuelticket/${res.data?.id}?ft_type=${res.data?.ft_type}`);
  };

  useEffect(() => {
    if (!location.state) return;
    setInput((prev) => ({
      ...prev,
      vehicle_type: location.state.truck_id ? 0 : 1,
      vehicle: location.state.truck_id ? null : { license_plate: location.state.refueler_license_plate, owner_company: location.state.provider_name },
      driver: location.state.truck_id ? null : { name: location.state.driver },
      inventory_cert: location.state.cert_no,
      ext_inv_serial: location.state.ext_inv_serial,
      billdate: moment(location.state.valid_date).format("YYYY-MM-DD"),
      note: location.state.note || "",
      invoiceproducts: [
        {
          ...initialProduct,
          position_no: location.state.position_no,
          quantity: location.state.quantity,
          temp: location.state.temp,
          density: location.state.density,
          d15: location.state.d15,
          vcf: location.state.vcf,
          wcf: location.state.wcf,
          l15: location.state.l15,
          kg: location.state.kg,
        },
      ],
    }));
  }, [location.state]);

  useEffect(() => {
    dispatch(setHeaderTitle((isReplace ? "PHÁT HÀNH THAY THẾ" : "TẠO") + " PHIẾU XUẤT TRẢ HÀNG GỬI TỪ KHO ĐẦU NGUỒN"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Paper style={{ marginTop: 20, margin: 5 }}>
      {/* <h1>{t((isReplace ? "Phát hành thay thế" : "Tạo") + " phiếu xuất trả hàng gửi kho đầu nguồn")}</h1> */}

      <div style={{ width: "98%", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gridGap: 20, marginTop: 20 }}>
        <FilterBy
          getDataFunc={() => getCustomers({ status: 1 })}
          triggerGetDataFunc={Boolean(user)}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, customer: option.find((item) => item.id === location.state.customer_id) }))}
          triggerSetDefaultFunc={location.state}
          value={input.customer}
          label={t("Khách hàng")}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, customer: newValue, invoiceproducts: prev.invoiceproducts.map((item) => ({ ...item, tank: null })) }))}
        />
        <FilterBy
          getDataFunc={() => getInventory({ status: 1, organization_id: user.organization_id })}
          triggerGetDataFunc={Boolean(user)}
          value={input.from_inventory}
          setDefaultFunc={(_, option) => setInput((prev) => ({ ...prev, from_inventory: option.find((item) => item.id === location.state.inventory_id) }))}
          triggerSetDefaultFunc={location.state}
          label={t("Kho xuất")}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, from_inventory: newValue }))}
        />
        <CustomDatePicker
          format="DD/MM/YYYY HH:mm:ss"
          outputFormat="YYYY-MM-DD HH:mm"
          label={t("Thời gian bắt đầu")}
          value={input.startdate}
          onChange={(value) => setInput((prev) => ({ ...prev, startdate: value }))}
          sx={{ width: "100%" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY HH:mm:ss"
          outputFormat="YYYY-MM-DD HH:mm"
          label={t("Thời gian kết thúc")}
          value={input.enddate}
          onChange={(value) => setInput((prev) => ({ ...prev, enddate: value }))}
          sx={{ width: "100%" }}
        />
        <Select fullWidth size="small" value={input.vehicle_type || 0} align="left" onChange={(e) => setInput((prev) => ({ ...prev, vehicle_type: e.target.value, vehicle: null, driver: null }))}>
          <MenuItem value={0}>Phương tiện trong hệ thống</MenuItem>
          <MenuItem value={1}>Phương tiện ngoài hệ thống</MenuItem>
        </Select>
        {input.vehicle_type ? (
          <TextField
            fullWidth
            label={t("Phương tiện")}
            value={input.vehicle?.license_plate || ""}
            onChange={(e) => setInput((prev) => ({ ...prev, vehicle: { ...prev.vehicle, license_plate: e.target.value } }))}
          />
        ) : (
          <FilterBy
            fullWidth
            label={t("Phương tiện")}
            getDataFunc={() => getVehicle({ status: 1, end_date: moment(Date.now()).format("YYYY-MM-DD"), groupvehicle_id: 455911 })}
            setDefaultFunc={(option) => location.state && setInput((prev) => ({ ...prev, vehicle: option.find((item) => item.id === location.state?.truck_id) }))}
            triggerSetDefaultFunc={location.state}
            value={input.vehicle}
            getOptionLabel={(option) => `${option.id} - ${option.license_plate}` || ""}
            filter={(option) => option.provider_id && JSON.parse(option.tanks)?.length}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, vehicle: newValue, driver: null, ext_vh_tanks: newValue && JSON.parse(newValue.tanks).map((item) => ({ ...item, lit: 0 })) }))}
          />
        )}
        <TextField
          fullWidth
          label="Công ty vận tải"
          disabled={!input.vehicle_type}
          value={input.vehicle?.owner_company || ""}
          onChange={(e) => setInput((prev) => ({ ...prev, vehicle: { ...prev.vehicle, owner_company: e.target.value } }))}
        />
        {input.vehicle_type ? (
          <TextField fullWidth label={t("Người điều khiển")} value={input.driver?.name || ""} onChange={(e) => setInput((prev) => ({ ...prev, driver: { ...prev.driver, name: e.target.value } }))} />
        ) : (
          <FilterBy
            fullWidth
            disabled={!input.vehicle}
            label={t("Người điều khiển")}
            getDataFunc={() => input.vehicle && getDriver({ provider_id: input.vehicle?.provider_id, status: 1 })}
            getDataDependencies={[input.vehicle]}
            filter={(option) => option.provider_id === input.vehicle?.provider_id}
            setDefaultFunc={(_, option) => location.state && setInput((prev) => ({ ...prev, driver: option.find((item) => item.id === location.state.driver_id) || null }))}
            triggerSetDefaultFunc={location.state}
            value={input.driver}
            getOptionLabel={(option) => option.name || ""}
            onChange={(e, newValue) => setInput((prev) => ({ ...prev, driver: newValue }))}
          />
        )}
        <FilterBy
          disabled
          label={t("Tên hàng hóa")}
          getDataFunc={() => getProduct({ status: 1 })}
          triggerSetDefaultFunc={true}
          setDefaultFunc={(option) => setInput((prev) => ({ ...prev, product: option.find((item) => (location.state ? item.id === location.state.product_id : item.id === 455496)) || null }))}
          value={input.product}
          onChange={(e, newValue) => setInput((prev) => ({ ...prev, product: newValue }))}
        />
        <TextField fullWidth label={t("Chứng chỉ số")} onChange={(e) => setInput((prev) => ({ ...prev, inventory_cert: e.target.value }))} value={input.inventory_cert} />
        <CustomDatePicker format="DD/MM/YYYY" value={input.billdate} label={t("Ngày thực hiện")} onChange={(value) => setInput((prev) => ({ ...prev, billdate: value }))} sx={{ width: "100%" }} />
        <TextField style={{ gridColumn: "span 1" }} fullWidth label={t("Ghi chú")} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} value={input.note} />
      </div>
      <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, textTransform: "uppercase" }}>{t("Thông tin hàng hóa")}</div>
      <div style={{ display: "flex" }}>
        <TextField value={dtype} onChange={(e) => setDtype(e.target.value)} select style={{ width: 200 }}>
          <MenuItem value={0}>Nhập DTT</MenuItem>
          <MenuItem value={1}>Nhập D15</MenuItem>
          <MenuItem value={2}>Nhập thủ công</MenuItem>
        </TextField>
      </div>
      {/* product table below */}
      {renderTable}
      <div align="left" style={{ marginTop: 20 }}>
        {/* button is disabled if required field is empty */}
        <ButtonGroup style={{ margin: 5 }}>
          <Button variant="contained" onClick={() => setDialogOpen(true)}>
            {t("Xem trước")}
          </Button>
          <ButtonWithAPICall api={handleSubmit} response={handleSubmitResponse} variant="contained" color="info">
            {t("Tạo phiếu")}
          </ButtonWithAPICall>
        </ButtonGroup>
      </div>
      <Dialog onClose={() => setDialogOpen(false)} open={dialogOpen}>
        <TruckFTReview data={{ ...data, inventory_name: input.inventory?.name }} />
      </Dialog>
    </Paper>
  );
}
export default CreateTruckTicket;

const TableProduct0 = ({ inputData, setInputData }) => {
  // boiler plate
  const [t] = useTranslation();
  const location = useLocation();
  const productRef = useRef();

  // methods
  const handleChangeProduct = (index, keyName, value) => {
    let newProduct = [...inputData.invoiceproducts];
    newProduct[index][keyName] = value;
    if (["temp", "density", "unit", "quantity"].includes(keyName)) {
      newProduct[index] = {
        ...newProduct[index],
        lit: "",
        d15: "",
        vcf: "",
        wcf: "",
        l15: "",
        kg: "",
        gallon: "",
      };
      // kiem tra dieu kien, neu thoa man thi goi api convert
      switch (keyName) {
        case "temp":
          newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "4.5 - 52" : undefined;
          break;
        case "density":
          newProduct[index].density_error = newProduct[index].density < 0.701 || newProduct[index].density > 0.873 ? "7010 - 8730" : undefined;
          break;
        default:
          break;
      }
      if (newProduct[index].quantity && newProduct[index].unit && newProduct[index].temp && newProduct[index].density && !newProduct[index].temp_error && !newProduct[index].density_error) {
        let { quantity, unit, temp, density } = newProduct[index];
        newProduct[index].loadingState = true;
        postConversion({
          quantity: quantity,
          unit: unit.id,
          temp: temp,
          density: density,
          method: 1,
        }).then((res) => {
          if (
            // kiem tra xem du lieu cu co giong du lieu hien tai khong, neu khong giong thi k update
            res.code === 200 &&
            quantity === productRef.current[index].quantity &&
            unit === productRef.current[index].unit &&
            temp === productRef.current[index].temp &&
            density === productRef.current[index].density
          ) {
            newProduct = productRef.current;
            newProduct[index] = {
              ...newProduct[index],
              lit: res.data.lit,
              d15: res.data.d15,
              vcf: res.data.vcf,
              wcf: res.data.wcf,
              l15: res.data.l15,
              kg: res.data.kg,
              gallon: res.data.gallon,
              loadingState: undefined,
            };
            setInputData((prev) => ({ ...prev, invoiceproducts: newProduct }));
          }
        });
      }
    }
    setInputData((prev) => ({ ...prev, invoiceproducts: newProduct }));
  };
  // effect
  useEffect(() => {
    productRef.current = inputData.invoiceproducts;
  }, [inputData.invoiceproducts]);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("STT")}</TableCell>
            <TableCell>{t("Tên hàng hóa")}</TableCell>
            <TableCell>{t("Số lượng")}</TableCell>
            <TableCell>{t("Nhiệt độ")} (℃)</TableCell>
            <TableCell>Dtt (Kg/cm3)</TableCell>
            <TableCell>D15</TableCell>
            <TableCell>VCF</TableCell>
            <TableCell>WCF</TableCell>
            <TableCell>
              {t("Số lượng")} ({t("lit")} 15℃)
            </TableCell>
            <TableCell>{t("Số lượng")} (kg)</TableCell>
            <TableCell>{t("Bồn xuất")}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {inputData.invoiceproducts.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{inputData.product?.name}</TableCell>
              <TableCell>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    size="small"
                    type="number"
                    variant="outlined"
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: "calc(100% - 100px)", minWidth: 150 }}
                    value={item.quantity}
                    onChange={(e) => handleChangeProduct(index, "quantity", e.target.value)}
                  />
                  <FilterBy
                    getDataFunc={() => getProductUnit({ status: 1 })}
                    value={item.unit}
                    triggerSetDefaultFunc={true}
                    setDefaultFunc={(_, option) =>
                      handleChangeProduct(
                        index,
                        "unit",
                        option.find((item) => (location.state?.receiptproduct[index]?.unit ? item.id === location.state.receiptproduct[index].unit : item.id === 21))
                      )
                    }
                    onChange={(e, newValue) => handleChangeProduct(index, "unit", newValue)}
                    filter={(option) => option.status === "ACTIVATED" && [21, 22].includes(option.id)}
                    style={{ width: 100 }}
                    getOptionLabel={(option) => option.name || ""}
                    label={t("Đơn vị tính")}
                    disableClearable
                  />
                </div>
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.temp_error)}
                  label={item.temp_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 100 }}
                  value={item.temp}
                  onChange={(e) => handleChangeProduct(index, "temp", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.density_error)}
                  label={item.density_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 150 }}
                  value={item.density && Math.round(item.density * 10000)}
                  onChange={(e) => handleChangeProduct(index, "density", e.target.value / 10000 || "")}
                />
              </TableCell>
              {item.loadingState ? (
                <TableCell colSpan={5}>
                  <Skeleton />
                </TableCell>
              ) : (
                <React.Fragment>
                  <TableCell>{item.d15 && parseFloat(item.d15).toFixed(4)}</TableCell>
                  <TableCell>{item.vcf && parseFloat(item.vcf).toFixed(4)}</TableCell>
                  <TableCell>{item.wcf && parseFloat(item.wcf).toFixed(4)}</TableCell>
                  <TableCell>{Math.round(item.l15)?.toLocaleString()}</TableCell>
                  <TableCell>{Math.round(item.kg)?.toLocaleString()}</TableCell>
                </React.Fragment>
              )}
              <TableCell>
                <Autocomplete
                  value={item.tank}
                  disableClearable
                  options={inputData.from_inventory?.tanks || []}
                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                  getOptionLabel={(option) => option.code || ""}
                  style={{ minWidth: "150px" }}
                  onChange={(e, newValue) => handleChangeProduct(index, "tank", newValue)}
                  renderInput={(params) => <TextField {...params} />}
                />
              </TableCell>
              <TableCell>
                <IconButton
                  variant="contained"
                  color="error"
                  onClick={() => inputData.invoiceproducts.length > 1 && setInputData((prev) => ({ ...prev, invoiceproducts: prev.invoiceproducts.filter((item, indexx) => indexx !== index) }))}
                >
                  <ClearIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
const TableProduct1 = ({ inputData, setInputData }) => {
  // boiler plate
  const [t] = useTranslation();
  const location = useLocation();
  const productRef = useRef();

  // methods
  const handleChangeProduct = (index, keyName, value) => {
    let newProduct = [...inputData.invoiceproducts];
    newProduct[index][keyName] = value;
    if (["temp", "d15", "unit", "quantity"].includes(keyName)) {
      newProduct[index] = {
        ...newProduct[index],
        lit: "",
        vcf: "",
        wcf: "",
        l15: "",
        kg: "",
        gallon: "",
      };
      // kiem tra dieu kien, neu thoa man thi goi api convert
      switch (keyName) {
        case "temp":
          newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "4.5 - 52" : undefined;
          break;
        case "d15":
          newProduct[index].density_error = newProduct[index].d15 < 0.701 || newProduct[index].d15 > 0.873 ? "7010 - 8730" : undefined;
          break;
        default:
          break;
      }
      if (newProduct[index].quantity && newProduct[index].unit && newProduct[index].temp && newProduct[index].d15 && !newProduct[index].temp_error && !newProduct[index].density_error) {
        let { quantity, unit, temp, d15 } = newProduct[index];
        newProduct[index].loadingState = true;
        postConversion({
          quantity: quantity,
          unit: unit.id,
          temp: temp,
          d15: d15,
          method: 1,
        }).then((res) => {
          if (
            // kiem tra xem du lieu cu co giong du lieu hien tai khong, neu khong giong thi k update
            res.code === 200 &&
            quantity === productRef.current[index].quantity &&
            unit === productRef.current[index].unit &&
            temp === productRef.current[index].temp &&
            d15 === productRef.current[index].d15
          ) {
            newProduct = productRef.current;
            newProduct[index] = {
              ...newProduct[index],
              lit: res.data.lit,
              vcf: res.data.vcf,
              wcf: res.data.wcf,
              l15: res.data.l15,
              kg: res.data.kg,
              gallon: res.data.gallon,
              loadingState: undefined,
            };
            setInputData((prev) => ({ ...prev, invoiceproducts: newProduct }));
          }
        });
      }
    }
    setInputData((prev) => ({ ...prev, invoiceproducts: newProduct }));
  };
  // effect
  useEffect(() => {
    productRef.current = inputData.invoiceproducts;
  }, [inputData.invoiceproducts]);

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("STT")}</TableCell>
            <TableCell>{t("Tên hàng hóa")}</TableCell>
            <TableCell>{t("Số lượng")}</TableCell>
            <TableCell>{t("Nhiệt độ")} (℃)</TableCell>
            <TableCell>D15 (Kg/cm3)</TableCell>
            <TableCell>VCF</TableCell>
            <TableCell>WCF</TableCell>
            <TableCell>
              {t("Số lượng")} ({t("lit")} 15℃)
            </TableCell>
            <TableCell>{t("Số lượng")} (kg)</TableCell>
            <TableCell>{t("Bồn xuất")}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {inputData.invoiceproducts.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{inputData.product?.name}</TableCell>
              <TableCell>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    size="small"
                    type="number"
                    variant="outlined"
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: "calc(100% - 100px)", minWidth: 150 }}
                    value={item.quantity}
                    onChange={(e) => handleChangeProduct(index, "quantity", e.target.value)}
                  />
                  <FilterBy
                    getDataFunc={() => getProductUnit({ status: 1 })}
                    value={item.unit}
                    triggerSetDefaultFunc={true}
                    setDefaultFunc={(_, option) =>
                      handleChangeProduct(
                        index,
                        "unit",
                        option.find((item) => (location.state?.receiptproduct[index]?.unit ? item.id === location.state.receiptproduct[index].unit : item.id === 21))
                      )
                    }
                    onChange={(e, newValue) => handleChangeProduct(index, "unit", newValue)}
                    filter={(option) => option.status === "ACTIVATED" && [21, 22].includes(option.id)}
                    getOptionLabel={(option) => option.name || ""}
                    label={t("Đơn vị tính")}
                    style={{ width: 120 }}
                    disableClearable
                  />
                </div>
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.temp_error)}
                  label={item.temp_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 100 }}
                  value={item.temp}
                  onChange={(e) => handleChangeProduct(index, "temp", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.density_error)}
                  label={item.density_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 150 }}
                  value={item.d15 && Math.round(item.d15 * 10000)}
                  onChange={(e) => handleChangeProduct(index, "d15", e.target.value / 10000 || "")}
                />
              </TableCell>
              {item.loadingState ? (
                <TableCell colSpan={5}>
                  <Skeleton />
                </TableCell>
              ) : (
                <React.Fragment>
                  <TableCell>{item.vcf && parseFloat(item.vcf).toFixed(4)}</TableCell>
                  <TableCell>{item.wcf && parseFloat(item.wcf).toFixed(4)}</TableCell>
                  <TableCell>{Math.round(item.l15)?.toLocaleString()}</TableCell>
                  <TableCell>{Math.round(item.kg)?.toLocaleString()}</TableCell>
                </React.Fragment>
              )}
              <TableCell>
                <Autocomplete
                  value={item.tank}
                  disableClearable
                  options={inputData.from_inventory?.tanks || []}
                  getOptionLabel={(option) => option.code || ""}
                  style={{ minWidth: "150px" }}
                  onChange={(e, newValue) => handleChangeProduct(index, "tank", newValue)}
                  renderInput={(params) => <TextField {...params} />}
                />
              </TableCell>
              <TableCell>
                <IconButton
                  variant="contained"
                  color="error"
                  onClick={() => inputData.invoiceproducts.length > 1 && setInputData((prev) => ({ ...prev, invoiceproducts: prev.invoiceproducts.filter((item, indexx) => indexx !== index) }))}
                >
                  <ClearIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
const TableProduct2 = ({ inputData, setInputData }) => {
  // boiler plate
  const [t] = useTranslation();
  const location = useLocation();

  // methods
  const handleChangeProduct = (index, keyName, value) => {
    console.log("handlechangeproduct", index, keyName, value);
    let newProduct = [...inputData.invoiceproducts];
    newProduct[index][keyName] = value;
    switch (keyName) {
      case "quantity":
        switch (newProduct[index].unit?.id) {
          case 21:
            newProduct[index].gallon = Math.round(value * 0.26417218);
            newProduct[index].lit = value;
            break;
          case 22:
            newProduct[index].lit = Math.round(value / 0.26417218);
            newProduct[index].gallon = value;
            break;
          default:
            break;
        }
        break;
      case "unit":
        switch (value.id) {
          case 21:
            newProduct[index].lit = newProduct[index].quantity;
            newProduct[index].gallon = Math.round(newProduct[index].quantity * 0.26417218);
            break;
          case 22:
            newProduct[index].gallon = newProduct[index].quantity;
            newProduct[index].lit = Math.round(newProduct[index].quantity / 0.26417218);
            break;
          default:
            break;
        }
        break;
      case "temp":
        newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "4.5 - 52" : undefined;
        break;
      case "d15":
        newProduct[index].density_error = newProduct[index].d15 < 0.701 || newProduct[index].d15 > 0.873 ? "7010 - 8730" : undefined;
        break;
      default:
        break;
    }
    setInputData((prev) => ({ ...prev, invoiceproducts: newProduct }));
  };

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("STT")}</TableCell>
            <TableCell>{t("Tên hàng hóa")}</TableCell>
            <TableCell>{t("Số lượng")}</TableCell>
            <TableCell>{t("Nhiệt độ")} (℃)</TableCell>
            <TableCell>D15 (Kg/cm3)</TableCell>
            <TableCell>VCF</TableCell>
            <TableCell>WCF</TableCell>
            <TableCell>
              {t("Số lượng")} ({t("lit")} 15℃)
            </TableCell>
            <TableCell>{t("Số lượng")} (kg)</TableCell>
            <TableCell>{t("Bồn xuất")}</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {inputData.invoiceproducts.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{inputData.product?.name}</TableCell>
              <TableCell>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    size="small"
                    type="number"
                    variant="outlined"
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: "calc(100% - 100px)", minWidth: 150 }}
                    value={item.quantity}
                    onChange={(e) => handleChangeProduct(index, "quantity", e.target.value)}
                  />
                  <FilterBy
                    getDataFunc={() => getProductUnit({ status: 1 })}
                    value={item.unit}
                    triggerSetDefaultFunc={true}
                    setDefaultFunc={(_, option) =>
                      handleChangeProduct(
                        index,
                        "unit",
                        option.find((item) => (location.state ? item.id === location.state.productunit_id : item.id === 21))
                      )
                    }
                    onChange={(e, newValue) => handleChangeProduct(index, "unit", newValue)}
                    filter={(option) => option.status === "ACTIVATED" && [21, 22].includes(option.id)}
                    style={{ width: 100 }}
                    getOptionLabel={(option) => option.name || ""}
                    label={t("Đơn vị tính")}
                    disableClearable
                  />
                </div>
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.temp_error)}
                  label={item.temp_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 100 }}
                  value={item.temp}
                  onChange={(e) => handleChangeProduct(index, "temp", e.target.value)}
                />
              </TableCell>
              <TableCell>
                <TextField
                  type="number"
                  error={Boolean(item.density_error)}
                  label={item.density_error}
                  inputProps={{ style: { textAlign: "center" } }}
                  style={{ width: 150 }}
                  value={item.d15 && Math.round(item.d15 * 10000)}
                  onChange={(e) => handleChangeProduct(index, "d15", e.target.value / 10000 || "")}
                />
              </TableCell>
              {item.loadingState ? (
                <TableCell colSpan={5}>
                  <Skeleton />
                </TableCell>
              ) : (
                <React.Fragment>
                  <TableCell>
                    <TextField
                      type="number"
                      inputProps={{ style: { textAlign: "center" } }}
                      style={{ width: 150 }}
                      value={item.vcf || ""}
                      onChange={(e) => handleChangeProduct(index, "vcf", e.target.value || "")}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      inputProps={{ style: { textAlign: "center" } }}
                      style={{ width: 150 }}
                      value={item.wcf || ""}
                      onChange={(e) => handleChangeProduct(index, "wcf", e.target.value || "")}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      inputProps={{ style: { textAlign: "center" } }}
                      style={{ width: 150 }}
                      value={item.l15 || ""}
                      onChange={(e) => handleChangeProduct(index, "l15", e.target.value || "")}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      inputProps={{ style: { textAlign: "center" } }}
                      style={{ width: 150 }}
                      value={item.kg || ""}
                      onChange={(e) => handleChangeProduct(index, "kg", e.target.value || "")}
                    />
                  </TableCell>
                </React.Fragment>
              )}
              <TableCell>
                <FilterBy
                  value={item.tank || null}
                  disableClearable
                  getDataFunc={() => Promise.resolve({ data: inputData.from_inventory?.tanks || [], code: 200 })}
                  getDataDependencies={[inputData.from_inventory]}
                  setDefaultFunc={(option) =>
                    handleChangeProduct(
                      index,
                      "tank",
                      option.find((item) => item.id === location.state.tank_id)
                    )
                  }
                  triggerSetDefaultFunc={location.state}
                  getOptionLabel={(option) => option.code || ""}
                  style={{ minWidth: "150px" }}
                  onChange={(e, newValue) => handleChangeProduct(index, "tank", newValue)}
                />
              </TableCell>
              <TableCell>
                <IconButton
                  variant="contained"
                  color="error"
                  onClick={() => inputData.invoiceproducts.length > 1 && setInputData((prev) => ({ ...prev, invoiceproducts: prev.invoiceproducts.filter((item, indexx) => indexx !== index) }))}
                >
                  <ClearIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
